module.exports = __webpack_public_path__ + "static/img/user_default.bf946a03.png";